"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PunchCorrectionCard = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const Row_1 = require("@amzn/atoz-web/Row");
const Col_1 = require("@amzn/atoz-web/Col");
const Button_1 = require("@amzn/atoz-web/Button");
const Modal_1 = require("@amzn/atoz-web/Modal");
const Text_1 = require("@amzn/atoz-web/Text");
const Responsive_1 = require("@amzn/atoz-web/Responsive");
const Theme_1 = require("@amzn/atoz-web/Theme");
const Popover_1 = require("@amzn/atoz-web/Popover");
const Link_1 = require("@amzn/atoz-web/Link");
const luxon_1 = require("luxon");
const DateManagement_1 = require("../../utils/DateManagement");
const contexts_1 = require("../../contexts");
const logger_1 = require("../../logger");
const PunchCorrectionCard = ({ correctionDateTime, correctionId, deleteEnabled, renderDeleteModal, renderPunchModal, renderPunchCorrectionConfirmationModal, militaryTime, cardIndex }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { matches } = (0, Responsive_1.useBreakpoints)();
    const punchCorrectionDateTime = luxon_1.DateTime.fromISO(correctionDateTime);
    const { clientName } = (0, contexts_1.useTaaConfigsContext)();
    const dimensions = {
        ClientName: clientName,
        ClientType: logger_1.ClientType.WEB
    };
    (0, logger_1.useComponentLoadedMetrics)({
        metricNames: {
            countMetricName: deleteEnabled
                ? logger_1.METRICS.PUNCH_CORRECTION_CARD_WITH_DELETE.COUNT
                : logger_1.METRICS.PUNCH_CORRECTION_CARD.COUNT
        },
        isComponentLoaded: true
    });
    const emitLog = (metricName) => {
        logger_1.logger.emitCountMetric({
            metricName,
            dimensions
        });
    };
    const punchCorrectionTime = (0, DateManagement_1.getTimeString)(punchCorrectionDateTime, militaryTime).toLocaleLowerCase();
    const punchCorrectionDate = punchCorrectionDateTime
        .toFormat('LLL d')
        .toLocaleUpperCase();
    const renderActionsWithoutDelete = () => {
        return (react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement(Modal_1.WithModal, { renderModal: renderPunchModal }, ({ open }) => (react_1.default.createElement(StyledButton, { key: "PunchCorrectionCardEditButton", variant: Button_1.ButtonVariant.Secondary, onClick: () => {
                    open();
                    emitLog(logger_1.METRICS.PUNCH_CORRECTION_CARD_EDIT_BUTTON_CLICK.COUNT);
                }, dataTestId: "PunchCorrectionCardEdit", "aria-label": t('time_and_attendance_PunchCorrectionCard_CorrectionsEdit_ariaLabel', {
                    date: punchCorrectionDate,
                    time: punchCorrectionTime
                }) }, t('time_and_attendance_PunchCorrectionCard_CorrectionsEdit')))),
            react_1.default.createElement(Modal_1.WithModal, { renderModal: renderPunchCorrectionConfirmationModal }, ({ open }) => (react_1.default.createElement(StyledButton, { key: "PunchCorrectionCardConfirmButton", variant: Button_1.ButtonVariant.Primary, onClick: () => {
                    open();
                    emitLog(logger_1.METRICS.PUNCH_CORRECTION_CARD_CONFIRM_BUTTON_CLICK.COUNT);
                }, dataTestId: "PunchCorrectionCardEditConfirm", "aria-label": t('time_and_attendance_PunchCorrectionCard_CorrectionsConfirm_ariaLabel', {
                    date: punchCorrectionDate,
                    time: punchCorrectionTime
                }) }, t('time_and_attendance_PunchCorrectionCard_CorrectionsConfirm'))))));
    };
    const renderActionsWithDelete = ({ close }) => (react_1.default.createElement(Col_1.Col, { alignItems: "flex-start" },
        react_1.default.createElement(Modal_1.WithModal, { renderModal: renderPunchCorrectionConfirmationModal }, ({ open }) => (react_1.default.createElement(StyledLink, { key: "PunchCorrectionCardConfirmButton", onClick: () => {
                open();
                emitLog(logger_1.METRICS.PUNCH_CORRECTION_CARD_CONFIRM_BUTTON_CLICK.COUNT);
            }, dataTestId: "PunchCorrectionCardEditConfirm", "aria-label": t('time_and_attendance_PunchCorrectionCard_CorrectionsConfirm_ariaLabel', {
                date: punchCorrectionDate,
                time: punchCorrectionTime
            }) }, t('time_and_attendance_PunchCorrectionCard_CorrectionsConfirmPunch')))),
        react_1.default.createElement(Modal_1.WithModal, { renderModal: renderPunchModal }, ({ open }) => (react_1.default.createElement(StyledLink, { key: "PunchCorrectionCardEditButton", onClick: () => {
                open();
                emitLog(logger_1.METRICS.PUNCH_CORRECTION_CARD_EDIT_BUTTON_CLICK.COUNT);
            }, dataTestId: "PunchCorrectionCardEdit", "aria-label": t('time_and_attendance_PunchCorrectionCard_CorrectionsEdit_ariaLabel', {
                date: punchCorrectionDate,
                time: punchCorrectionTime
            }) }, t('time_and_attendance_PunchCorrectionCard_CorrectionsEditPunch')))),
        react_1.default.createElement(Modal_1.WithModal, { renderModal: renderDeleteModal }, ({ open }) => (react_1.default.createElement(StyledLink, { key: "PunchCorrectionCardDeleteButton", onClick: () => {
                open();
                emitLog(logger_1.METRICS.PUNCH_CORRECTION_CARD_DELETE_BUTTON_SUBMIT.COUNT);
            }, dataTestId: "PunchCorrectionCardDelete", "aria-label": t('time_and_attendance_PunchCorrectionCard_CorrectionsDelete_ariaLabel', { date: punchCorrectionDate, time: punchCorrectionTime }) }, t('time_and_attendance_PunchCorrectionCard_CorrectionsDeletePunch'))))));
    return (react_1.default.createElement(react_1.default.Fragment, { key: correctionId },
        react_1.default.createElement(Row_1.Row, { dataTestId: `missed-punch-correction-row-${correctionId}`, justifyContent: "space-between", margin: { top: 'S200', bottom: 'S200' }, gridGap: matches.s ? 'S200' : 'S400' },
            react_1.default.createElement(Col_1.Col, { flex: "1" },
                react_1.default.createElement(Text_1.Text, { color: "neutral70", fontSize: "T200" }, t('time_and_attendance_PunchCorrectionCard_CorrectionsMissedPunchIndex', {
                    number: cardIndex + 1
                })),
                react_1.default.createElement(Row_1.Row, { alignItems: "end", gridGap: "S200" },
                    react_1.default.createElement(Text_1.Text, { fontSize: "T400", fontWeight: "bold", dataTestId: `punch-correction-time-${cardIndex}` }, punchCorrectionTime),
                    react_1.default.createElement(Text_1.Text, { color: "neutral80", fontSize: "T200", dataTestId: `punch-correction-date-${cardIndex}` }, punchCorrectionDate))),
            react_1.default.createElement(Col_1.Col, { justifyContent: "center" },
                react_1.default.createElement(Row_1.Row, { alignItems: "center", justifyContent: "flex-end", gridGap: "S200", padding: "S200" }, deleteEnabled ? (react_1.default.createElement(Popover_1.Popover, { key: "PunchCorrectionCardActionsButton", triggerText: t('time_and_attendance_PunchCorrectionCard_CorrectionsActions'), triggerButtonProps: { hasOutline: true }, shouldCloseOnFocusLeave: false, position: Popover_1.PopoverPosition.BottomTrailing, dataTestId: "PunchCorrectionCardActionsButton", "aria-label": t('time_and_attendance_PunchCorrectionCard_CorrectionsActions_ariaLabel') }, renderActionsWithDelete)) : (renderActionsWithoutDelete())))),
        react_1.default.createElement("div", { className: "atoz-dashed-line atoz-dashed-line--non-extended" })));
};
exports.PunchCorrectionCard = PunchCorrectionCard;
const StyledButton = (0, Theme_1.styledWithTheme)(Button_1.Button) `
    min-width: unset;
`;
const StyledLink = (0, Theme_1.styledWithTheme)(Link_1.Link)(({ theme }) => `
    cursor: pointer;
    font-weight: 400;
    display: block;
    margin-bottom: ${theme.selectors.space('S300')}px;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
    &:last-of-type {
        margin-bottom: 0;
    }
  `);
